// style
import { useNavigate, useParams } from "react-router-dom";
import styles from "../Styles/PrintFactor.module.css";
import { useContext, useEffect, useState } from "react";
import { Context } from "../Context/Context";
import { toast } from "react-toastify";
import { getFactor } from "../Services/ContectService";
import { sysAdminAddress } from "../Services/ContectService";
import { sysAdminData } from "../Services/ContectService";
import Notfound from "../Components/Common/Notfound";
import moment from "jalali-moment";
import QuoteImage from "../Components/Common/QuoteImage";
import { getProvinceName } from "../Utils/getProvinceName";

const PrintFactor = () => {
  const { json, loading, setLoading, user } = useContext(Context);
  let navigate = useNavigate();
  let params = useParams();

  const [sysAddress, setSysAddress] = useState(null);
  const getSysAdminAddressHandler = async () => {
    setLoading(true);
    try {
      const { status, data } = await sysAdminAddress(user);
      if (status === 200) {
        setSysAddress(data);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const [sysData, setSysData] = useState(null);
  const getSysAdminDataHandler = async () => {
    setLoading(true);
    try {
      const { status, data } = await sysAdminData(user);
      if (status === 200) {
        setSysData(data);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const [data, setData] = useState();
  const getDetailfactorHandeler = async () => {
    setLoading(true);
    try {
      const { status, data } = await getFactor(user, params.id);
      if (status === 200) {
        setData(data);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSysAdminAddressHandler();
    getDetailfactorHandeler();
    getSysAdminDataHandler();
  }, []);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center px-2 py-5 h3">
          لطفاً صبر کنید...
        </div>
      ) : data ? (
        <section className={styles.sectionPrintFactor}>
          <div className={styles.header_printFactor}>
            <div className={styles.right_header}>
              <button onClick={() => navigate(-1)}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.2002 9.59999C5.2002 9.26862 5.46882 8.99999 5.8002 8.99999H12.7517L10.1759 6.42425C9.94162 6.18994 9.94162 5.81004 10.1759 5.57572C10.4102 5.34141 10.7901 5.34141 11.0245 5.57572L14.6245 9.17572C14.8588 9.41004 14.8588 9.78994 14.6245 10.0243L11.0245 13.6243C10.7901 13.8586 10.4102 13.8586 10.1759 13.6243C9.94162 13.3899 9.94162 13.01 10.1759 12.7757L12.7517 10.2H5.8002C5.46882 10.2 5.2002 9.93136 5.2002 9.59999Z"
                    fill="#FFF"
                  />
                </svg>
              </button>
              <img src="/imgs/wisercam logo.svg" alt="Wisercam" />
            </div>
            <div className={styles.left_header}>
              <button onClick={() => navigate(-1)}> برگشت </button>
              <button onClick={() => window.print()}> پرینت</button>
            </div>
          </div>
          <div className={styles.factor}>
            <table>
              <tbody className={styles.thead}>
                <tr>
                  <th colSpan="2">فاکتور </th>
                  <th colSpan="5">
                    <img
                      src="/imgs/wisercam logo.svg"
                      className="mx-auto"
                      alt="Wisercam"
                    />
                  </th>
                  <th colSpan="2">
                    فاکتور : {data.code}
                    <br />
                    تاریخ :{" "}
                    {moment(data.order_date, "YYYY/MM/DD")
                      .locale("fa")
                      .format("YYYY/MM/DD")}
                  </th>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <th colSpan="9">مشخصات فروشنده</th>
                </tr>
                <tr>
                  <td colSpan="3">نام شخص حقیقی/حقوقی : {sysData?.name}</td>
                  <td colSpan="3">
                    شماره ملی : {sysData?.national_id}
                  </td>
                  <td colSpan="3">
                    ایمیل : {sysData?.email}
                  </td>
                </tr>
                <tr>
                  <td colSpan="3">
                    استان : {getProvinceName(sysData?.province)}
                  </td>
                  <td colSpan="3">شهر : {sysData?.city}</td>
                  <td colSpan="3">کد پستی : {sysData?.postal_code}</td>
                </tr>
                <tr>
                  <td colSpan="6">آدرس/ دفتر مرکزی: {sysData?.registration_address}</td>
                  <td colSpan="3">
                    شماره تلفن : {sysData?.registration_phone_number}
                  </td>
                </tr>
                <tr>
                  <td colSpan="3">
                    شماره ثبت : {sysData?.registration_number}
                  </td>
                  <td colSpan="3">
                    شماره اقتصادی : {sysData?.economic_code}
                  </td>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <th colSpan="9"> مشخصات خریدار</th>
                </tr>
                <tr>
                  <td colSpan="3">
                    نام شخص حقیقی/حقوقی :{" "}
                    {data.order_company
                      ? data.order_company.name
                      : `${data.user_detail.name} ${data.user_detail.family}`}
                    {/* {data.custom_receiver_first_name &&
                    data.custom_receiver_last_name
                      ? `${data.custom_receiver_first_name} ${data.custom_receiver_last_name}`
                      : `${data.user_detail.name} ${data.user_detail.family}`} */}
                  </td>
                  <td colSpan="3">
                    شماره ملی :{" "}
                    {data.order_company
                      ? data.order_company.national_id
                      : data.user_detail.national_code}
                  </td>
                  <td colSpan="3">
                    ایمیل :{" "}
                    {
                      data.order_company
                      ? data.order_company.email
                      : data.custom_receiver_email || data.user_detail.email
                    }
                  </td>
                </tr>
                <tr>
                  <td colSpan="3">
                    استان :{" "}
                    {getProvinceName(
                      data.order_company
                        ? data.order_company.province
                        : data.order_address?.province
                    )}
                  </td>
                  <td colSpan="3">
                    شهر :{" "}
                    {data.order_company
                      ? data.order_company.city
                      : data.order_address?.city}
                  </td>
                  <td colSpan="3">
                    کد پستی :{" "}
                    {data.order_company ? data.order_company.postal_code : data.order_address ? data.order_address.postal_code : null}
                  </td>
                </tr>
                <tr>
                  <td colSpan="6">
                    آدرس :{" "}
                    {data.order_company
                      ? data.order_company.registration_address
                      : data.order_address
                      ? data.order_address.physical_address
                      : null}
                  </td>
                  <td colSpan="9">
                    شماره تلفن :{" "}
                    {/* {data.custom_receiver_phone_number ||
                      data.user_detail.phone_number} */}
                    { data.order_company
                    ? data.order_company.registration_phone_number
                    : data.order_address
                    ? data.order_address.phone_number
                    : data.user_detail.phone_number
                    }
                  </td>
                </tr>
                <tr>
                  <td colSpan="3">
                    شماره ثبت : {data.order_company?.registration_number}
                  </td>
                  <td colSpan="3">
                    شماره اقتصادی : {data.order_company?.economic_code}
                  </td>
                </tr>
              </tbody>

              <tbody>
                <tr>
                  <th colSpan="9"> مشخصات خدمت/خدمات مورد معامله </th>
                </tr>
                <tr>
                  <td>سطر</td>
                  <td>کد خدمت</td>
                  <td colSpan="3">شرح خدمت</td>
                  <td>تعداد</td>
                  <td>مبلغ</td>
                  <td colSpan="2">تصویر</td>
                </tr>

                {data.services_detail.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.code}</td>
                    <td colSpan="3">ماشین کاری</td>
                    <td>{item.quantity}</td>
                    <td>
                      {Number.isNaN(Number(item.total_price))
                        ? `${item.total_price}0`
                        : `${Number(`${item.total_price}0`).toLocaleString()} ریال`}
                    </td>
                    <td colSpan="2" className="text-center">
                      {item.image ? (
                        <QuoteImage
                          code={item.code}
                          className={`${styles.serviceImage} mx-auto`}
                          onClick={() => navigate(`/DetailOrder/${item.code}`)}
                        />
                      ) : (
                        <img
                          src="/imgs/upload/wisercam image.png"
                          alt="Wisercam"
                          className={`${styles.serviceImage} mx-auto`}
                          onClick={() => navigate(`/DetailOrder/${item.code}`)}
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tbody>
                <tr>
                  <th colSpan="9">مشخصات تکمیلی خرید</th>
                </tr>
                <tr>
                  <td colSpan="2">
                    نحوه پرداخت :
                    {data.payment_type === "p"
                      ? "پیش پرداخت "
                      : data.payment_type === "t"
                      ? "تایید دو مرحله ای "
                      : data.payment_type === "c"
                      ? "بر اساس قرارداد "
                      : "آنلاین"}
                  </td>

                  <td colSpan="2">
                    هزینه حمل و نقل :{" "}
                    {Number.isNaN(Number(data.transfer_price))
                      ? `${data.transfer_price}0`
                      : `${Number(`${data.transfer_price}0`).toLocaleString()} ریال`}
                  </td>
                  <td colSpan="2">
                    تخفیف :{" "}
                    {Number.isNaN(Number(data.discount_amount))
                      ? `${data.discount_amount}0`
                      : `${Number(
                          `${data.discount_amount}0`
                        ).toLocaleString()} ریال`}
                  </td>

                  <td>
                    {" "}
                    مالیات بر ارزش افزوده:{" "}
                    {Number.isNaN(Number(data.tax))
                      ? `${data.tax}0`
                      : `${Number(`${data.tax}0`).toLocaleString()} ریال`}
                  </td>

                  <td colSpan="3">
                    مجموع مبلغ فاکتور :{" "}
                    {Number.isNaN(Number(data.payment_price))
                      ? `${data.payment_price}0`
                      : `${Number(`${data.payment_price}0`).toLocaleString()} ریال`}
                  </td>
                </tr>
              </tbody>
              <tbody></tbody>

              <tbody>
                <tr>
                  <th colSpan="9">وضعیت پرداخت</th>
                </tr>

                <tr>
                  <td colSpan="2">فیش پرداخت</td>
                  <td colSpan="2">تاریخ سررسید</td>
                  <td colSpan="2">مبلغ</td>
                  <td colSpan="2">وضعیت پرداخت</td>
                </tr>

                {data.order_installment.map((item, index) => (
                  <tr key={index}>
                    <td colSpan="2">{index + 1}</td>
                    <td colSpan="2">
                      {" "}
                      {moment(item.pay_date, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                    </td>
                    <td colSpan="2">
                      {" "}
                      {Number.isNaN(Number(item.amount))
                        ? `${item.amount}0`
                        : `${Number(`${item.amount}0`).toLocaleString()} ریال`}
                    </td>
                    <td colSpan="2">
                      {item.is_paid ? "پرداخت شده" : "در انتظار پرداخت"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      ) : (
        <Notfound />
      )}
    </>
  );
};

export default PrintFactor;
